<template>
  <div class="setComponent">
    <!-- 表单 -->
    <div class="wrap-form">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="180px" class="form-setting float-l">
        <el-form-item :label="$i18n.t('custom_lang_0122')">
          <el-input v-model="ruleForm.mobileText" :placeholder="$i18n.t('custom_lang_0124')" disabled></el-input>
           <el-button v-show="countShow" @click="obtainVerificationCode('ruleForm')">{{$t("custom_lang_0128")}}</el-button>
           <el-button v-show="!countShow" disabled>{{count}}{{$t("custom_lang_0129")}}</el-button>
           <span class="c999 ml20">{{$t("custom_lang_0131")}}</span>
        </el-form-item>
        <el-form-item :label="$i18n.t('custom_lang_0123')" prop="code">
          <el-input v-model="ruleForm.code" :placeholder="$i18n.t('custom_lang_0125')" maxlength="6"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{$t("custom_lang_0136")}}</el-button>
          <el-button @click="resetForm('ruleForm')">{{$t("wm_lang_html_625fb2")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <br><br>
  </div>
</template>

<script>
  import xmail from '@/api/api';
  export default {
    name: 'unBindMobile',
    data() {
      let mobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('custom_lang_0124')));
        } else if(!/^1[35789]\d{9}$/.test(value)){
          callback(new Error(this.$i18n.t('custom_lang_0126')));
        } else {
          callback();
        }
      };
      let code = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('custom_lang_0125')));
        } else if(!/^\d{6}$/.test(value)){
          callback(new Error(this.$i18n.t('custom_lang_0127')));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          mobile: '',
          mobileText: '',
          code: ''
        },
        rules: {
          mobile: [
            { validator: mobile, trigger: 'blur' }
          ],
          code: [
            { validator: code, trigger: 'blur' }
          ]
        },
        localConfigSetting: {},
        verificationCodeDisabled: false,
        countShow: true,
        count: "",
        timer: null
      };
    },
    mounted() {
      this.ruleForm.mobile = this.$route.params.mobile;
      this.ruleForm.mobileText = this.$route.params.mobileText;
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let self = this;
            (function (api, enums, pms) {
              let pm = pms.Account.unbindMobileParamBuilder();
              pm.mobile = self.ruleForm.mobile;
              pm.code = self.ruleForm.code;
              api.Account.unbindMobile(pm, function (res) {
                if(res.data.code === 0) {
                  self.$message({
                    type: 'success',
                    message: self.$i18n.t('custom_lang_0135')
                  });
                  self.$router.push({name: 'accountSecurity'});
                } else {
                  /*let eMsg = self.$GetErrorMsg(res.data.code);
                  self.$message({
                    type: 'error',
                    message: eMsg
                  });*/
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        // this.$refs[formName].resetFields();
        this.$router.push({name: 'accountSecurity'});
      },
      obtainVerificationCode(formName) {
        let self = this;
        const TIME_COUNT = 60;
        if(!self.timer){
          self.count = TIME_COUNT;
          self.countShow = false;
          self.timer = setInterval (() =>{
            if(self.count > 0 && self.count <= TIME_COUNT){
              self.count--;
              self.verifyText = self.count+self.$i18n.t('custom_lang_0129');
            } else {
              self.countShow = true;
              clearInterval(self.timer);
              self.timer = null;
            }
          },1000);
        }
        (function (api, enums, pms) {
          let pm = pms.Account.sendCodeParamBuilder();
          pm.mobile = self.ruleForm.mobile;
          pm.templateType = 27;
          api.Account.sendCode(pm, function (res) {
            if(res.data.code === 0) {
              self.$message({
                type: 'success',
                message: self.$i18n.t('custom_lang_0130')
              });
            } else if(res.data.code === enums.ErrorCode.NOTIFIER_CODE_LIMIT_ERROR) {
              self.count = 30;
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;overflow: hidden;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/unBindMobile.vue